import React from "react";
import { Button } from "@/components/ui/button";
import { DiscordIcon, DISCORD_INVITE_URL } from "./SiteFooter";

/**
 * Compact Discord invite card used in place of the old email-capture box.
 * Two variants: `hero` (large, on the homepage hero grid) and `inline` (issue detail bottom).
 * Neo-brutalist: flat cream surface, hard ink border, solid offset shadow.
 */
export const DiscordInviteCard = ({ variant = "hero", testId = "discord-invite-card" }) => {
  const isHero = variant === "hero";
  return (
    <div
      data-testid={testId}
      className={"nb-box relative " + (isHero ? "p-6 sm:p-8" : "p-6")}
    >
      <div className="flex items-center gap-3">
        <div className="inline-flex h-11 w-11 items-center justify-center border-2 border-[color:var(--coh-ink)] bg-[color:var(--coh-blue)] text-[color:var(--coh-on-accent)]">
          <DiscordIcon className="h-6 w-6" />
        </div>
        <div className="kicker">Join the Discord</div>
      </div>
      <h2
        className={
          "mt-4 font-display font-extrabold tracking-tight text-[color:var(--coh-ink)] " +
          (isHero ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl")
        }
      >
        Meet other humans on Discord.
      </h2>
      <p className={"mt-3 leading-relaxed text-[color:var(--coh-ink-muted)] " + (isHero ? "text-sm sm:text-base" : "text-sm")}>
        Join the Cohnect Discord to share what you’re working on, meet thoughtful people, and make
        new connections. A friendly, low-noise space for founders, creators, and anyone who values
        meaningful conversation.
      </p>
      <div className="mt-6">
        <Button
          asChild
          size="lg"
          data-testid={`${testId}-join-button`}
          className="btn-nb btn-nb-primary h-12 px-6 w-full sm:w-auto"
        >
          <a href={DISCORD_INVITE_URL} target="_blank" rel="noopener noreferrer">
            <DiscordIcon className="h-5 w-5 mr-2" />
            Join the Discord <span aria-hidden="true" className="font-mono ml-1">↗</span>
          </a>
        </Button>
      </div>
    </div>
  );
};
